// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__K2SLM","item":"PaymentsMobile_item__2vBb9","label":"PaymentsMobile_label__31Rdh","amount":"PaymentsMobile_amount__1S-4N"};